import Cookies from 'js-cookie'
import { parsePhoneNumberFromString } from 'libphonenumber-js/min'

import { isSubOnlyRegistration } from '../../zendrop-vue3/src/shared/subOnly'

export default {
  isValidURL(str) {
    const pattern = new RegExp(
      '^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$',
      'i',
    ) // fragment locator
    return !!pattern.test(str)
  },

  trimShopifyURL(storeUrl) {
    if (storeUrl.includes('.myshopify.com')) {
      return this.trimStoreURL(storeUrl)
    }
    if (storeUrl.indexOf('http://') === 0 || storeUrl.indexOf('https://') === 0) {
      storeUrl = storeUrl.replace(/^https?\:\/\//i, '')
    }
    storeUrl = storeUrl.split(':')[0]
    storeUrl = storeUrl.split('?')[0]
    let delimiter = '/'
    let urlParts = storeUrl.split(delimiter).slice(0, 3)
    return urlParts.join(delimiter)
  },

  trimStoreURL(store_url) {
    // remove https or http from url if exist
    if (store_url.indexOf('http://') === 0 || store_url.indexOf('https://') === 0) {
      store_url = store_url.replace(/^https?\:\/\//i, '')
    }
    if (store_url.indexOf('//') > -1) {
      store_url = store_url.split('/')[2]
    } else {
      store_url = store_url.split('/')[0]
    }

    // find & remove port number
    store_url = store_url.split(':')[0]
    // find & remove "?"
    store_url = store_url.split('?')[0]

    return store_url
  },

  addHttps(url) {
    if (!/^(?:f|ht)tps?\:\/\//.test(url)) {
      url = 'https://' + url
    }
    return url
  },

  isPaymentMethodNotFound(status_code) {
    return status_code === 901
  },

  isTransactionErrorFound(status_code) {
    return status_code === 902
  },

  collectNavIds(data) {
    let ids = []

    const traverse = (items) => {
      items.forEach((item) => {
        ids.push(item.id)
        if (item.children && item.children.length > 0) {
          traverse(item.children)
        }
      })
    }

    traverse(data)
    return ids
  },

  getCookieDomain() {
    let arr = window.location.hostname.split('.')
    return arr.length >= 2 ? `.${arr[arr.length - 2]}.${arr[arr.length - 1]}` : arr[0]
  },

  setCookie(name, value, domain, days = null) {
    let expires = ''
    if (days !== null) {
      const d = new Date()
      d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000)
      expires = 'expires=' + d.toUTCString() + ';'
    }
    document.cookie = name + '=' + value + ';' + expires + 'path=/;domain=' + domain
  },

  getAffiliateUrl(partner) {
    const affiliatePartners = {
      copyfy: 'https://zendrop.com/copyfy',
      'checkout-dropshipping-com': 'https://zendrop.com/checkout-dropshipping-com',
      'checkout-minea-special-en': 'https://zendrop.com/checkout-minea-special-en',
      'checkout-minea-special-fr': 'https://zendrop.com/checkout-minea-special-fr',
    }

    return affiliatePartners[partner] || ''
  },

  formatUniversalPhone(raw) {
    const str = String(raw ?? '').trim()
    if (!str) return ''

    const phone = parsePhoneNumberFromString(str)
    if (!phone) return str

    // Extract pieces
    const cc = phone.countryCallingCode    // ✅ real CC (1, 44, 370, …)
    const rest = phone.nationalNumber      // just digits without country code

    const a = rest.slice(0, 3)
    const b = rest.slice(3, 6)
    const c = rest.slice(6, 10)

    if (a && b && c) return `+${cc} (${a}) ${b}-${c}`
    if (a && b) return `+${cc} (${a}) ${b}`
    if (a) return `+${cc} (${a})`
    return `+${cc}`
  },

  formExternalAttrSetter(form, sourceSSO = false) {
    const affiliateConnectorId = Cookies.get('affiliate_connector_id') ?? null
    const affiliateType = Cookies.get('affiliate_type') ?? null
    const urlParams = new URLSearchParams(window.location.search)
    const referralNameParam = urlParams.get('referral_name') ?? null
    const subOnly = isSubOnlyRegistration()

    if (subOnly) {
      form.ubb_prohibited = sourceSSO ? 1 : true
    } else {
      form.ubb_prohibited = sourceSSO ? 0 : false
    }

    if (referralNameParam) {
      form.referral_name = referralNameParam
    }

    if (affiliateConnectorId && affiliateType) {
      form.affiliate_type = affiliateType
      form.affiliate_connector_id = affiliateConnectorId
    }
  },

  getUrlParams() {
    const urlParams = new URLSearchParams(window.location.search)
    const queryObj = {}
    for (const [key, value] of urlParams.entries()) {
      queryObj[key] = value
    }
    return queryObj
  },

  getCurrentPlan(user) {
    if (!user) return null
    if (user?.has_usage_based_billing) return 'UBB'
    if (user?.is_pro_user) return 'pro'
    if (user?.is_plus_user) return 'plus'
    if (user?.is_free_user) return 'free'
    if (user?.is_select_user) return 'private agent'
    return null
  },
}
